// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../routes/routes";
import { supportedLanguages } from "../../../i18n/supported-languages";
import phrasebookLoad from "../../../i18n";
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { capitalizeFirstLetter } from "../../../helpers/util"

// Redux
import { accountActions, notificationTypeActions } from 'actions';

// Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class NotificationTypeEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.match.params.id,
      functionality: undefined,
      notification_type: undefined,
      functionality_id: undefined,
      customer_id: undefined,
      action: undefined,
      default_receiver_account_type_id: [],
      default_receiver_account_id: undefined,
      alert_user: false,
      alert_group: false,
      alert_email: false,
      alert_client: false,
      account_types: undefined,
      accounts: undefined,
      submitted: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {
    if (token.loggedAccountType() < 200) {
      this.props.dispatch(accountActions.getAllAccountTypes(0, this.state.page, { pccwglobal_account_type: true }));
      this.props.dispatch(accountActions.getAllAccounts(this.state.limit, 0, { orderby: 'account_type_id', asc: true }));
    } else {
      this.props.dispatch(accountActions.getAllCustomerAccountTypes(0, this.state.page));
      this.props.dispatch(accountActions.getAllByCustomer(this.state.limit, 0, { orderby: 'account_type_id', asc: true }));
    }

    this.props.dispatch(notificationTypeActions.get(this.props.match.params.id));

  }

  componentDidUpdate(prevProps) {
    if (this.props.account_types && prevProps && prevProps.account_types !== this.props.account_types) {
      this.setState({ account_types: this.props.account_types.data });
    }
    if (this.props.accounts && prevProps && prevProps.accounts !== this.props.accounts) {
      this.setState({ accounts: this.props.accounts.data });
    }
    if (this.props.notificationtype && prevProps && prevProps.notificationtype !== this.props.notificationtype) {
      this.setState({
        functionality_id: this.props.notificationtype.functionality_id,
        functionality: this.props.notificationtype.functionality,
        customer_id: this.props.notificationtype.customer_id,
        action: this.props.notificationtype.action,
        default_receiver_account_type_id: this.props.notificationtype.default_receiver_account_type_id,
        default_receiver_account_id: this.props.notificationtype.default_receiver_account_id,
        alert_user: this.props.notificationtype.alert_user,
        alert_group: this.props.notificationtype.alert_group,
        alert_email: this.props.notificationtype.alert_email,
        alert_client: this.props.notificationtype.alert_client,
        notification_type: this.props.notificationtype,
        submitted: false
      });
    }
  }

  handleChange(e) {
    const { id, name, value, checked, type } = e.target;
    if (type === 'checkbox' && checked !== undefined) {
      if (id === 'default_receiver_account_type_id') {
        if (checked === true && !this.state[id].includes(name)) {
          var arraytemp = this.state[id];
          arraytemp.push(name);
          this.setState({
            [id]: arraytemp
          })
        } else if (checked === false && this.state[id].includes(name)) {
          let result = this.state[id].filter(e => e !== name);
          this.setState({
            [id]: result
          })
        }
      } else {
        this.setState({ [id]: checked });
      }
    }
    else if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = {
      functionality_id: this.state.functionality_id,
      customer_id: this.state.customer_id,
      action: this.state.action,
      default_receiver_account_type_id: this.state.default_receiver_account_type_id,
      default_receiver_account_id: this.state.default_receiver_account_id,
      alert_user: this.state.alert_user,
      alert_group: this.state.alert_group,
      alert_email: this.state.alert_email,
      alert_client: this.state.alert_client,
    }
    this.props.dispatch(notificationTypeActions.update(this.state.id, newValues))
  }

  FormProfile = () => {
    if (this.state.account_types && this.state.accounts && this.state.notification_type) {

      const accountOptions = this.state.account_types.map(function (account_type) {
        return { value: account_type['id'], label: capitalizeFirstLetter(account_type['account_type']) };
      });
      const accountUserOptions = this.state.accounts.map(function (account) {
        return { value: account['id'], label: capitalizeFirstLetter(account['username']) };
      });
      const inputs = [
        { label: phrasebook.headerlinks.category, type: "text", placeholder: this.state.functionality.category, id: "category", name: "category", value: this.state.functionality.category, disabled: true },
        { label: phrasebook.headerlinks.sub_category, type: "text", placeholder: this.state.functionality.sub_category, id: "sub_category", name: "sub_category", value: this.state.functionality.sub_category, disabled: true },

        { label: phrasebook.status.action, type: "text", placeholder: this.state.action, id: "action", name: "action", value: this.state.action, disabled: true },


        { label: phrasebook.alerts.default_account_type_receiver, type: "section" },

        token.loggedAccountType() < 200 ?
          [{ label: phrasebook.notifications.administrators, type: "checkbox", id: "default_receiver_account_type_id", name: "100", value: this.state.default_receiver_account_type_id.includes('100') ? true : false },
          { label: phrasebook.notifications.sales_team, type: "checkbox", id: "default_receiver_account_type_id", name: "110", value: this.state.default_receiver_account_type_id.includes('110') ? true : false },
          { label: phrasebook.notifications.product_team, type: "checkbox", id: "default_receiver_account_type_id", name: "120", value: this.state.default_receiver_account_type_id.includes('120') ? true : false },
          { label: phrasebook.notifications.operations_team, type: "checkbox", id: "default_receiver_account_type_id", name: "130", value: this.state.default_receiver_account_type_id.includes('130') ? true : false },
          { label: phrasebook.notifications.billing_team, type: "checkbox", id: "default_receiver_account_type_id", name: "140", value: this.state.default_receiver_account_type_id.includes('140') ? true : false }] : [{ label: phrasebook.notifications.master, type: "checkbox", id: "default_receiver_account_type_id", name: "200", value: this.state.default_receiver_account_type_id.includes('200') ? true : false },
          { label: phrasebook.notifications.sales_team, type: "checkbox", id: "default_receiver_account_type_id", name: "210", value: this.state.default_receiver_account_type_id.includes('210') ? true : false },
          { label: phrasebook.notifications.product_team, type: "checkbox", id: "default_receiver_account_type_id", name: "220", value: this.state.default_receiver_account_type_id.includes('220') ? true : false },
          { label: phrasebook.notifications.operations_team, type: "checkbox", id: "default_receiver_account_type_id", name: "230", value: this.state.default_receiver_account_type_id.includes('230') ? true : false },
          { label: phrasebook.notifications.billing_team, type: "checkbox", id: "default_receiver_account_type_id", name: "240", value: this.state.default_receiver_account_type_id.includes('240') ? true : false }],







        // { label: phrasebook.alerts.default_user_receiver, type: "select", id: "default_receiver_account_type_id", name: "default_receiver_account_type_id", options: accountUserOptions, selected: this.state.default_receiver_account_type_id, empty_option: true },


        // { label: phrasebook.alerts.alert_user, type: "checkbox", id: "alert_user", name: "alert_user", value: this.state.alert_user },
        // { label: phrasebook.alerts.alert_group, type: "checkbox", id: "alert_group", name: "alert_group", value: this.state.alert_group },
        // { label: phrasebook.alerts.alert_by_email, type: "checkbox", id: "alert_email", name: "alert_email", value: this.state.alert_email },
        // { label: phrasebook.alerts.alert_by_portal, type: "checkbox", id: "alert_client", name: "alert_client", value: this.state.alert_client },

      ]
      const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.administration.notification_type.list} />, <SubmitButton title={phrasebook.common.update} />]
      return (
        <Form
          handleSubmit={this.handleSubmit}
          onChange={this.handleChange}
          title={`${phrasebook.common.update} ${phrasebook.headerlinks.permission}`}
          inputs={inputs}
          buttons={buttons}
        />)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.administration.notification_type.list, label: phrasebook.headerlinks.notification_types }]} current={`${phrasebook.common.edit} ${phrasebook.headerlinks.notification_type}`} />

      {this.FormProfile()}
    </>
  }
}

function mapStateToProps(state) {
  const { loggedpermissions, account, authentication, notificationtype } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    account_types: account.account_types,
    accounts: account.accounts,
    notificationtype: notificationtype.notificationtype
  };
}


const notificationTypeEdit = connect(mapStateToProps)(NotificationTypeEdit);
export default (notificationTypeEdit);
